/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {Period}              from '@/util/period';
import {TSOEditor}           from './t.s.o.editor';

/**
 *
 * @class SetDurationCommand
 *
 * @brief reversible updates of the tso duration column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetDurationCommand implements ICommand {

  private oldValue: Period;
  private newValue: Period;
  private editor:   TSOEditor;

  constructor(oldValue: Period, newValue: Period, editor: TSOEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setDuration(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setDuration(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof Period) ? this.oldValue.asString() : '';
    const b = (this.newValue instanceof Period) ? this.newValue.asString() : '';

    return '[duration] ' + a + ' => ' + b;
  }

}
